import styled from "styled-components";

export const DropdownHRElemt = styled.div`
    hr {
        margin-bottom: 12px;
        border-top: ${({ theme }) => `1px solid ${theme.v3.colors.grey88}`};
    }
`;
